import { checkCarrierServesPostcode } from "@components/commerce/baseForms/utils/checkCarrierServesPostcode";
import type { PostalCodeValidator } from "../types";
import { errorResult, successResult } from "../utils";

export const validateSE: PostalCodeValidator = async (args) => {
    const { postalCode, isBillingForm, headers, carrierCode } = args;
    if (isBillingForm) return successResult();
    if (!postalCode?.trim()) return successResult();

    const servesPostcode = await checkCarrierServesPostcode({
        country: "SE",
        carrierCode,
        postalCode,
    });

    if (servesPostcode) {
        return successResult();
    }

    return errorResult(headers?.errors?.undeliverableAddress ?? "", "invalidPostalCodeCarrier");
};
